// services/newsService.ts
import http from '@/utils/http' // Assuming you have a configured http client
import { CommentResponse, NewsResponse, PostResponse } from '@/models/news.model'

/**
 * Fetch news articles with pagination and optional menuSlug filter.
 */
export const fetchNews = async (
  page: number = 1,
  size: number = 10,
  menuSlug?: string
): Promise<NewsResponse> => {
  const response = await http.get<NewsResponse>('news', {
    params: { page, size, menuSlug },
  })
  return response
}

export const searchNews = async ({
  page = 1,
  size = 10,
  menuSlug = '',
  search = '',
}: {
  page?: number
  size?: number
  menuSlug?: string
  search?: string
}): Promise<NewsResponse> => {
  const response = await http.get<NewsResponse>('/news', {
    params: { page, size, menuSlug, search },
  })
  return response
}

export const fetchPost = async (slug: string = ''): Promise<PostResponse> => {
  const response = await http.get<PostResponse>(`/admin-console/news/${slug}`)
  return response
}

// Comment API
export const fetchComments = async (
  newsId: string = '',
  raoVatId: string = ''
): Promise<CommentResponse> => {
  const response = await http.get<CommentResponse>('/comments', {
    params: { newsId, raoVatId },
  })
  return response // Ensure this matches the CommentResponse type
}

export const addComment = async ({
  newsId,
  raoVatId,
  content,
  anonymousEmail,
  anonymousName,
}: {
  newsId?: string
  raoVatId?: string
  content: string
  anonymousEmail?: string
  anonymousName?: string
}): Promise<void> => {
  await http.post('/comments', {
    newsId,
    raoVatId,
    content,
    anonymousEmail,
    anonymousName,
  })
}
export const fetchArticle = async (slug: string): Promise<PostResponse | null> => {
  if (!slug) return null // Nếu `slug` không hợp lệ, trả về `null`

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/admin-console/news/${slug}`,
      {
        next: { revalidate: 60 }, // Cache trong 60 giây (Next.js 14)
      }
    )

    if (!response.ok) throw new Error('Failed to fetch post')

    return response.json()
  } catch (error) {
    throw Error('Error fetching post:' + error)
  }
}
export const fetchNewsList = async (
  page: number = 1,
  size: number = 10,
  menuSlug: string = ''
): Promise<NewsResponse | null> => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/news?page=${page}&size=${size}&menuSlug=${menuSlug}`,
      {
        next: { revalidate: 60 }, // Cache trong 60 giây (Next.js 14)
      }
    )

    if (!response.ok) throw new Error('Failed to fetch post')

    return response.json()
  } catch (error) {
    throw Error('Error fetching post:' + error)
  }
}
